module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select2.48ee4ef8.png";